import { render } from "./DashboardLabels.vue?vue&type=template&id=13a43d18"
import script from "./DashboardLabels.vue?vue&type=script&lang=js"
export * from "./DashboardLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__